module.exports = __webpack_public_path__ + "static/media/testimonials-annie.eb61e098.png";